import {
  Disney,
  FOX,
  Honda,
  KIA,
  Lexus,
  Pixar,
  SouthPark,
  TheSimpsons,
  U2,
} from "ui/Logos";

export const caseStudies = [
  {
    id: "disney",
    logoComponent: Disney,
    title: "Disney",
    projects: [
      {
        title: "Official Mickey Mouse Homepage",
        gallery: [
          "mickey_1.jpg",
          "mickey_2.jpg",
          "mickey_3.jpg",
          "mickey_4.jpg",
          "mickey_5.jpg",
          "mickey_6.jpg",
        ],
      },
      {
        title: "Winnie the Pooh",
        gallery: ["pooh_1.jpg", "pooh_2.jpg", "pooh_3.jpg", "pooh_4.jpg"],
      },
      {
        title: "The Muppets",
        gallery: [
          "muppets_1.jpg",
          "muppets_2.jpg",
          "muppets_3.jpg",
          "muppets_4.jpg",
          "muppets_5.jpg",
          "muppets_6.jpg",
        ],
      },
      {
        title: "Disney Share Internal Website",
        gallery: ["disney_share_1.jpg", "disney_share_2.jpg"],
      },
    ],
  },
  {
    id: "pixar",
    logoComponent: Pixar,
    title: "Pixar Animation Studios",
    projects: [
      {
        title: "Finding Nemo 3D Website",
        gallery: [
          "nemo_1.jpg",
          "nemo_2.jpg",
          "nemo_3.jpg",
          "nemo_4.jpg",
          "nemo_5.jpg",
        ],
      },
    ],
  },
  {
    id: "simpsons",
    logoComponent: TheSimpsons,
    title: "The Simpsons",
    projects: [
      {
        title: "25th Anniversary Website",
        gallery: [
          "simpsons_1.jpg",
          "simpsons_2.jpg",
          "simpsons_3.jpg",
          "simpsons_4.jpg",
        ],
      },
    ],
  },
  {
    id: "southpark",
    logoComponent: SouthPark,
    title: "South Park Studios",
    projects: [
      {
        title: "Avatar Creator",
        gallery: [
          "southpark_1.jpg",
          "southpark_2.jpg",
          "southpark_3.jpg",
          "southpark_4.jpg",
        ],
      },
      {
        title: "The Stick of Truth",
        gallery: ["southpark_5.jpg", "southpark_6.jpg"],
      },
    ],
  },
  {
    id: "fox",
    logoComponent: FOX,
    title: "Fox Broadcasting Company",
    projects: [
      {
        title: "Glee Photo Booth",
        gallery: [
          "gleepb_1.jpg",
          "gleepb_2.jpg",
          "gleepb_3.jpg",
          "gleepb_4.jpg",
        ],
      },
      {
        title: "Test your Glee N A",
        gallery: [
          "gleena_1.jpg",
          "gleena_2.jpg",
          "gleena_3.jpg",
          "gleena_4.jpg",
        ],
      },
      {
        title: "Fox Holiday Snowball Fight",
        gallery: ["snow_1.jpg", "snow_2.jpg", "snow_3.jpg", "snow_4.jpg"],
      },
      {
        title: "Human Target Practice",
        gallery: ["ht_1.jpg", "ht_2.jpg", "ht_3.jpg", "ht_4.jpg"],
      },
    ],
  },
  {
    id: "kia",
    logoComponent: KIA,
    title: "KIA",
    projects: [
      {
        title: "KIA Soul Website",
        gallery: [
          "kia_soul_1.jpg",
          "kia_soul_2.jpg",
          "kia_soul_3.jpg",
          "kia_soul_4.jpg",
        ],
      },
      {
        title: "KIA Soul Shuffle Slam",
        gallery: [
          "kia_slam_1.jpg",
          "kia_slam_2.jpg",
          "kia_slam_3.jpg",
          "kia_slam_4.jpg",
          "kia_slam_5.jpg",
        ],
      },
    ],
  },
  {
    id: "honda",
    logoComponent: Honda,
    title: "Honda",
    projects: [
      {
        title: "Super Civic Quest",
        gallery: ["honda_1.jpg", "honda_2.jpg", "honda_3.jpg", "honda_4.jpg"],
      },
    ],
  },
  {
    id: "lexus",
    logoComponent: Lexus,
    title: "Lexus",
    projects: [
      {
        title: "Lexus Hybrids Website",
        gallery: ["lexus_1.jpg", "lexus_2.jpg", "lexus_3.jpg", "lexus_4.jpg"],
      },
    ],
  },
  {
    id: "u2",
    logoComponent: U2,
    title: "U2",
    projects: [
      {
        title: "U2 360 Tour Website",
        gallery: ["u2_1.jpg", "u2_2.jpg", "u2_3.jpg", "u2_4.jpg", "u2_5.jpg"],
      },
    ],
  },
];
